export const rulesViolated = {
    moneyLaundry: 'Blanqueo de dinero',
    fraud: 'Estafa',
    forgery: 'Falsificación de documentos',
    theft: 'Hurto',
    secondOffence: 'Otra infracción de la ley',
    dontKnow: 'No lo sé',
};
